
$( document ).ready(function() {
$('#ProductSelect-oz1b-option-0>div:first-child label').html('3 Pack<br/><em>(for 1x daily)</em>');
$('#ProductSelect-oz1b-option-0>div:last-child label').html('6 Pack<br/><em>(for 2x daily)</em>');
$('#ProductSelect-oz1b-option-0>div:last-child').append('<span class="nfs-best-saving">Best Value</span>');

$('#AddToCartForm-oz1b input[name="purchaseType"][value="purchaseTypeOneTime"]').next().remove();
$('#AddToCartForm-oz1b input[name="purchaseType"][value="purchaseTypeOneTime"]').after('<span>One-time purchase (15%): <span id="one_time_price" data-rtx-onetime-price="" class="oz1price"> <strike>$90.00</strike> $76.50</span></span>' );
$('#AddToCartForm-oz2b input[name="purchaseType"][value="purchaseTypeOneTime"]').next().remove();
$('#AddToCartForm-oz2b input[name="purchaseType"][value="purchaseTypeOneTime"]').after('<span>One-time purchase (15%): <span id="one_time_price" data-rtx-onetime-price="" class="oz3price"><strike>$99.00</strike> $84.15</span></span>' );

$('#AddToCartForm-oz3b input[name="purchaseType"][value="purchaseTypeOneTime"]').next().remove();
$('#AddToCartForm-oz3b input[name="purchaseType"][value="purchaseTypeOneTime"]').after('<span>One-time purchase (15%): <span id="one_time_price" data-rtx-onetime-price="" class="oz3price"><strike>$90.00</strike> $76.50</span></span>' );
$('#AddToCartForm-oz4b input[name="purchaseType"][value="purchaseTypeOneTime"]').next().remove();
$('#AddToCartForm-oz4b input[name="purchaseType"][value="purchaseTypeOneTime"]').after('<span>One-time purchase (15%): <span id="one_time_price" data-rtx-onetime-price="" class="oz4price"><strike>$99.00</strike> $84.15</span></span>' );

});

$(document).ready(function(){
setTimeout(function(){
      //       $('.rc_label__onetime').html('One-time purchase: <b>$54.00</b>');
    $('#AddToCartForm-oz1b .sub_percent').text('(40%)');
    $('#AddToCartForm-oz1b .sub_price').text('$54.00');
    $('#AddToCartForm-oz1b .sub_percent').attr("id","subpercent");
    $('#AddToCartForm-oz2b .sub_percent').attr("id","subpercent");
    $('.sub_percent').removeAttr('id');
    $('#AddToCartForm-oz1b .sub_price').removeAttr("data-rtx-subscription-price");
    $('#AddToCartForm-oz1b .rtx_strike').removeAttr("data-rtx-onetime-price");

    $('#AddToCartForm-oz1b span').removeAttr("data-rtx-onetime-price");
    $('#AddToCartForm-oz3b span').removeAttr("data-rtx-onetime-price");

    $('#AddToCartForm-oz2b span').removeAttr("data-rtx-onetime-price");
    $('#AddToCartForm-oz4b span').removeAttr("data-rtx-onetime-price");

      //  $('#AddToCartForm-oz1b .rtx-subscription>div>label:first-child .sub_price').after('<div class="rtxshotsubprice"></div>');
      //  $('#AddToCartForm-oz1b .rtx-subscription>div>label:last-child #one_time_price').after('<div class="rtx-shot-one-price"></div>');
      
      $('#AddToCartForm-oz1b .rtx-subscription-label .rtxshotsubprice').text('($2.25 per Dose shot)');
      //$('#AddToCartForm-oz1bpld .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.88 per Dose shot)');
      $('#AddToCartForm-oz1b .rtx-subscription-label .rtxshotsubprice').removeClass('rtx-shot-sub-price');
      $('#AddToCartForm-oz2b .rtx-subscription-label .rtxshotsubprice').removeClass('rtx-shot-sub-price');
      $('#AddToCartForm-oz1b .onetime .rtx-shot-one-price').text('($3.19 per Dose shot)');
      $('#AddToCartForm-oz2b .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.88 per Dose shot)');
      $('#AddToCartForm-oz2b .rtx-subscription>div>label:last-child .onetime .rtxshotsubprice').text('($4.13 per Dose shot)');


}, 300);

});
$(document).ready(function(){
setTimeout(function(){
$('.rc_label__deliver_every').after('<p class="nfs-nocomitment">No commitment, cancel anytime</p>');
}, 300);

});

$("#ProductSelect-oz1b-option-0>div:first-child").click(function() {
$('#purchaseTypeSubscription-7697614143729---AddToCartForm-oz1b').click();
setTimeout(function(){     
$('#AddToCartForm-oz1b .sub_percent').text('(40%)');
$('#AddToCartForm-oz1b .sub_price').text('$54.00');
$('.sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-oz1b .rtx_strike').text('$90.00');
$('#AddToCartForm-oz1b .rtx_strike').removeAttr("data-rtx-onetime-price");
  $('#AddToCartForm-oz1b .rtx-subscription-label .rtxshotsubprice').text('($2.25 per Dose shot)');
  
$('#AddToCartForm-oz1b .onetime .rtx-shot-one-price').text('($3.19 per Dose shot)');
$('.oz1price').html('<strike>$90.00</strike> $76.50');
$('.oz3price').html('<strike>$90.00</strike> $76.50');
}, 300);
});    

$("#ProductSelect-oz1b-option-0>div:last-child").click(function() {
$('#purchaseTypeSubscription-7697614143729---AddToCartForm-oz1b').click();
setTimeout(function(){     
$('#AddToCartForm-oz1b .sub_percent').text('(40%)');
$('#AddToCartForm-oz1b .sub_price').text('$96.00');
$('.sub_price').removeAttr("data-rtx-subscription-price");
$('#AddToCartForm-oz1b .rtx_strike').text('$160.00');
$('#AddToCartForm-oz1b .rtx_strike').removeAttr("data-rtx-onetime-price");
  $('#AddToCartForm-oz1b .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.00 per Dose shot)');
$('#AddToCartForm-oz1b .onetime .rtx-shot-one-price').text('($2.83 per Dose shot)');
$('.oz1price').html('<strike>$160.00</strike> $136.00');
$('.oz3price').html('<strike>$160.00</strike> $136.00');


}, 300);
});




jQuery('.oztab>span:first-child').click(function() {
    $(this).addClass('active');
    $('.oztab>span:last-child').removeClass('active');
    $('#AddToCartForm-oz1b').show();
    $('#AddToCartForm-oz2b').hide();
 
    $('.main-pr1').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1_84e07148-2221-4ad4-89c0-2ca6334e09d1_2000x.png?v=1748868498");
    $('.main-pr11').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1_84e07148-2221-4ad4-89c0-2ca6334e09d1_2000x.png?v=1748868498");
      $('.edumrp').text('$54.00');
    $('.edusp').text('$54.00');
  $('.gdi').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/AMZ07_LIVER_SFP_PDP_e8f2d9b3-57be-4e70-b508-499baf11fa96.jpg?v=1760250143");
  
$('.oz1price').html('<strike>$90.00</strike> $76.50');
  });

jQuery('.oztab>span:last-child').click(function() {
      $(this).addClass('active');
      $('.oztab>span:first-child').removeClass('active');
      $('#AddToCartForm-oz1b').hide();
      $('#AddToCartForm-oz2b').show();
      $('.main-pr1').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1C_1_2000x.png?v=1748868678");
      $('.main-pr11').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1C_1_2000x.png?v=1748868678");
     
      $('.gdi').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/W10_Liver_2oz.png?v=1760457033");
    
     $('#AddToCartForm-oz2b .sub_percent').text('(40%)');
      $('#AddToCartForm-oz2b .sub_price').text('$59.40');
   $('#AddToCartForm-oz2b .sub_price').removeAttr("data-rtx-subscription-price");
      $('#AddToCartForm-oz2b .rtx_strike').removeAttr("data-rtx-onetime-price");
     
      $('#AddToCartForm-oz2b .sub_price').removeClass('sub_price');
      $('#AddToCartForm-oz2b .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.48 per Dose shot)');
      $('#AddToCartForm-oz2b .rtx-subscription>div>label:first-child .rtxshotsubprice').removeClass('rtx-shot-one-price');;
      
      $('#AddToCartForm-oz2b .rtx-subscription>div>label:last-child .rtx-shot-one-price').text('($3.51 per Dose shot)');
      $('.edumrp').text('$99.00');
      $('.edusp').text('$59.40');
      $('.oz3price').html('<strike>$99.00</strike> $84.15');
});

  jQuery('#ProductSelect-oz1b-option-0>div:first-child').click(function() {
 $('.main-pr1').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1B.png?v=1748868497");
    $('.main-pr11').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1B.png?v=1748868497");

  });
  jQuery('#ProductSelect-oz1b-option-0>div:nth-child(2)').click(function() {
 $('.main-pr1').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1_84e07148-2221-4ad4-89c0-2ca6334e09d1.png?v=1748868498");
     $('.main-pr11').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/image_1_84e07148-2221-4ad4-89c0-2ca6334e09d1.png?v=1748868498");

  });



 



jQuery('.pr-img1 img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.main-pr1').attr('src', thissrc);
jQuery('.pr-img1 img').removeClass('activepr');
jQuery(this).addClass('activepr');
});

jQuery('.pr-img4 img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.main-pr4').attr('src', thissrc);
jQuery('.pr-img4 img').removeClass('activepr');
jQuery(this).addClass('activepr');
});

$(document).ready(function(){
setTimeout(function(){
$('.nfs-nocomitment').html('<ul><li><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="11.1548" cy="11.1548" r="11.1265" fill="#57665C" stroke="#FDF4E7" stroke-width="0.0567677"/> <path d="M6.8125 12.8295L9.82119 15.7247L15.5263 6.58508" stroke="#FDF4E7" stroke-width="1.41919" stroke-linecap="round"/> </svg><span>Save 15% on recurring orders</span></li><li><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="11.1548" cy="11.1548" r="11.1265" fill="#57665C" stroke="#FDF4E7" stroke-width="0.0567677"/> <path d="M6.8125 12.8295L9.82119 15.7247L15.5263 6.58508" stroke="#FDF4E7" stroke-width="1.41919" stroke-linecap="round"/> </svg><span>Unlock long-term liver health* by drinking 2-4 ounces a day!</span></li></li> <li><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="11.1548" cy="11.1548" r="11.1265" fill="#57665C" stroke="#FDF4E7" stroke-width="0.0567677"/> <path d="M6.8125 12.8295L9.82119 15.7247L15.5263 6.58508" stroke="#FDF4E7" stroke-width="1.41919" stroke-linecap="round"/> </svg><span>No commitments! Adjust or cancel anytime</span></li> <li><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="11.1548" cy="11.1548" r="11.1265" fill="#57665C" stroke="#FDF4E7" stroke-width="0.0567677"/> <path d="M6.8125 12.8295L9.82119 15.7247L15.5263 6.58508" stroke="#FDF4E7" stroke-width="1.41919" stroke-linecap="round"/> </svg><span>30-Day Money-back Guarantee**</span></li></ul>');
}, 2000);
});


$(".liveraction").click(function() {
  $(this).toggleClass('flipcardliveri');
$(this).children('.liveraction-inner').toggleClass('flipcardliver');
});


$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 50
    }, 500);
});